import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import MfaSetup from './MfaSetup';

export default function MfaConfirmIndex(props) {
    return (
        <MfaSetup
            qrCodeUrl={props.qrCodeUrl}
            mfaSettingsUrl={props.mfaSettingsUrl}
            confirmUrl={props.confirmUrl}
            recoveryCodesUrl={props.recoveryCodesUrl}
            redirectAfterAdd={props.redirectAfterAdd}
            redirectUrl={props.redirectUrl}
            sendDeviceAddedUrl={props.sendDeviceAddedUrl}
            isMfaActivated={props.isMfaActivated}
            isMfaRequired={props.isMfaRequired}
            isMfaConfirmed={props.isMfaConfirmed}
            activateUrl={props.activateUrl}
            deactivateUrl={props.deactivateUrl}
        />
    );
}

if (document.getElementById('mfaConfirm')) {
    var rootEl = document.getElementById('mfaConfirm');
    ReactDOM.render(
        <App>
            <MfaConfirmIndex
                qrCodeUrl={qrCodeUrl}
                mfaSettingsUrl={mfaSettingsUrl}
                confirmUrl={confirmUrl}
                recoveryCodesUrl={recoveryCodesUrl}
                redirectAfterAdd={true}
                redirectUrl={redirectUrl}
                sendDeviceAddedUrl={sendDeviceAddedUrl}
                isMfaActivated={isMfaActivated}
                isMfaRequired={isMfaRequired}
                isMfaConfirmed={isMfaConfirmed}
                activateUrl={activateUrl}
                deactivateUrl={deactivateUrl}
            />
        </App>,
        rootEl,
    );
}
